/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  SafetyClusterLogic,
  SafetyClusterLogicInterface,
} from "../../../contracts/safetyCluster/SafetyClusterLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "planetCount",
        type: "uint256",
      },
    ],
    name: "birth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxNumber",
        type: "uint256",
      },
    ],
    name: "getBill",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "category",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isIn",
            type: "bool",
          },
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "tokenType",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "nftIds",
            type: "uint256[]",
          },
        ],
        internalType: "struct GenericSafetyClusterType.Bill[]",
        name: "ret",
        type: "tuple[]",
      },
      {
        internalType: "bool",
        name: "hasMore",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getConfig",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "rndBase",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "planetCount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "planetIndex",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "billIndex",
            type: "uint256",
          },
        ],
        internalType: "struct GenericSafetyClusterType.Config",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "category",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "getErc20Balance",
    outputs: [
      {
        internalType: "uint256",
        name: "categoryBalance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "planetReportBalance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "planetActualBalance",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getInteractedCategory",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "",
        type: "bytes32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getInteractedTokens",
    outputs: [
      {
        internalType: "address[]",
        name: "erc20tokens",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "erc721tokens",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "erc1155tokens",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "category",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeFrom",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "giveErc1155",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "category",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeFrom",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "giveErc20",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "category",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeFrom",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "nftId",
        type: "uint256",
      },
    ],
    name: "giveErc721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "category",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeFrom",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "nftIds",
        type: "uint256[]",
      },
    ],
    name: "giveErc721s",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "fromCategory",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "toCategory",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeTo",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeFrom",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "moveErc1155",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "fromCategory",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "toCategory",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeTo",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeFrom",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "moveErc20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "fromCategory",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "toCategory",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeTo",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeFrom",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "nftId",
        type: "uint256",
      },
    ],
    name: "moveErc721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "fromCategory",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "toCategory",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeTo",
        type: "address",
      },
      {
        internalType: "address",
        name: "fakeFrom",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "nftIds",
        type: "uint256[]",
      },
    ],
    name: "moveErc721s",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nova",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "category",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "takeErc1155",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "category",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "takeErc20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "category",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "nftId",
        type: "uint256",
      },
    ],
    name: "takeErc721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "category",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "nftIds",
        type: "uint256[]",
      },
    ],
    name: "takeErc721s",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type SafetyClusterLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SafetyClusterLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SafetyClusterLogic__factory extends ContractFactory {
  constructor(...args: SafetyClusterLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<SafetyClusterLogic> {
    return super.deploy(overrides || {}) as Promise<SafetyClusterLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): SafetyClusterLogic {
    return super.attach(address) as SafetyClusterLogic;
  }
  override connect(signer: Signer): SafetyClusterLogic__factory {
    return super.connect(signer) as SafetyClusterLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SafetyClusterLogicInterface {
    return new utils.Interface(_abi) as SafetyClusterLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SafetyClusterLogic {
    return new Contract(address, _abi, signerOrProvider) as SafetyClusterLogic;
  }
}
